// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.articletypes.articletype', {
        url: '/{articleTypeId}',
        views: {
            "baseView@base": {
                templateUrl: 'main/base/articletypes/articletype/articletype.tpl.html',
                controller: 'ArticleTypeController as vm'
            }
        },
        resolve: {
            articleType: articleTypesResolver,
            createNew: function () { return false; }
        }
    });

    $stateProvider.state('base.articletypes.new', {
        url: '/new',
        views: {
            "baseView@base": {
                templateUrl: 'main/base/articletypes/articletype/articletype.tpl.html',
                controller: 'ArticleTypeController as vm'
            }
        },
        resolve: {
            articleType: function () { return {}; },
            createNew: function () { return true; }
        }
    });
}



// @ngInject
function articleTypesResolver($stateParams, ArticleTypesApiService) {
    return ArticleTypesApiService.getArticleType($stateParams.articleTypeId);
}


// @ngInject
function ArticleTypeController($state, articleType, loadSpinnerService, ArticleTypesApiService, createNew, $scope, $translate, ToasterService, confirmationDialogService) {
    var vm = this;

    vm.articleType = articleType;
    vm.isEditing = false;
    vm.isNew = false;
    vm.articleTypeCopy = {};
    vm.devFeaturesEnabled = localStorage.getItem('devFeature_reactArticleTypeView') !== 'false';
    vm.reactArticleTypeId = createNew ? null : (articleType && articleType.id != null ? articleType.id : null);

    // functions
    vm.save = save;
    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.delete = deleteArticleType;

    // initialize
    if (createNew) {
        vm.isNew = true;
        vm.isEditing = true;
    }

    function save() {
        ArticleTypesApiService.save(vm.articleType).then(function (result) {
            vm.articleType.id = result.data.id;
            vm.isEditing = false;
            vm.isNew = false;
            ToasterService.showSuccess('"' + vm.articleType.name + '" ' + $translate.instant("common.wasSaved"), $translate.instant("base.articletypes"));

        }, function (error) {
            ToasterService.showError(error.message, $translate.instant("base.articletypes"));
        }).finally(function () {
            vm.isEditing = false;
            vm.isNew = false;
            $state.go('base.articletypes.articletype', { articleTypeId: vm.articleType.id });
        });
    }

    function enableEditing() {
        vm.articleTypeCopy = angular.copy(vm.articleType);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.articleType = angular.copy(vm.articleTypeCopy);
        vm.isEditing = false;
    }

    function deleteArticleType() {

        confirmationDialogService.showDialog($translate.instant("articletype.confirmDelete")).then(function (deleteConfirmed) {
            if (deleteConfirmed === true) {
                ArticleTypesApiService.deleteArticleType(vm.articleType.id).then(function () {
                    ToasterService.showSuccess('"' + vm.articleType.name + '" ' + $translate.instant("common.wasDeleted"), $translate.instant("base.articletypes"));
                }, function (error) {
                    ToasterService.showError($translate.instant(error.data.message), $translate.instant("base.articletypes"));
                }).finally(function () {
                    vm.isEditing = false;
                    vm.isNew = false;
                    $state.go('base.articletypes');
                });
            }
        });
    }
}


angular
    .module('articletypes.articletype', [])
    .config(stateConfig)
    .controller('ArticleTypeController', ArticleTypeController);
